// -------------------------------------
// Dependencies
// -------------------------------------
import 'snippets/card/card';
import './_sharpener-product-select.scss';

// -------------------------------------
// Variables
// -------------------------------------
const ITEM_SELECTOR = '.sharpener-product-select__item';
const HEADING_SELECTOR = '[data-dynamic-heading]';
const SHARPENER_TYPE_PARAM = 'sharpener_type';
const DESTINATION_PARAM = 'destination';

class iamSharpenerProductSelect extends HTMLElement {

    constructor() {
        super();

        this.accessoryTypeStepUrl = this.dataset.accessoryTypeStepUrl;

        this.applyFilterFromParams();
        this.updateDynamicHeading();
        this.routeThroughAccessoryTypeStep();
    }

    routeThroughAccessoryTypeStep() {
        // No step 3 page configured — leave every tile's direct link to its
        // compatible accessories collection untouched.
        if (!this.accessoryTypeStepUrl) return;

        const sharpenerType = new URLSearchParams(window.location.search).get(SHARPENER_TYPE_PARAM);

        this.querySelectorAll(`${ITEM_SELECTOR} a`).forEach((link) => {
            link.addEventListener('click', (e) => {
                e.preventDefault();

                const stepUrl = new URL(this.accessoryTypeStepUrl, window.location.origin);

                stepUrl.searchParams.set(DESTINATION_PARAM, link.href);

                if (sharpenerType) {
                    stepUrl.searchParams.set(SHARPENER_TYPE_PARAM, sharpenerType);
                }

                window.location.href = stepUrl.toString();
            });
        });
    }

    isValidSharpenerType(sharpenerType) {
        if (!sharpenerType) return false;

        const items = this.querySelectorAll(ITEM_SELECTOR);

        return Array.from(items).some((item) => item.dataset.sharpenerType === sharpenerType);
    }

    applyFilterFromParams() {
        const sharpenerType = new URLSearchParams(window.location.search).get(SHARPENER_TYPE_PARAM);

        // Missing or unrecognized type falls back to showing every sharpener rather than an empty grid.
        if (!this.isValidSharpenerType(sharpenerType)) return;

        this.querySelectorAll(ITEM_SELECTOR).forEach((item) => {
            item.style.display = item.dataset.sharpenerType === sharpenerType ? '' : 'none';
        });
    }

    updateDynamicHeading() {
        const heading = this.querySelector(HEADING_SELECTOR);

        if (!heading) return;

        const sharpenerType = new URLSearchParams(window.location.search).get(SHARPENER_TYPE_PARAM);
        const template = heading.dataset.headingTemplate;

        // Missing or unrecognized type falls back to the default heading already rendered.
        if (!this.isValidSharpenerType(sharpenerType) || !template) return;

        heading.textContent = template.replace('[type]', sharpenerType);
    }
}

customElements.define('iam-sharpener-product-select', iamSharpenerProductSelect);
